import { Tournament } from '../models';
import { ParticipantRepository, TournamentRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class GetUserTournamentsUseCase {
  constructor(
    private participantRepository: ParticipantRepository,
    private tournamentRepository: TournamentRepository
  ) {}

  async execute(userId: string): Promise<Tournament[]> {
    logger.debug('GetUserTournaments', 'Fetching tournaments for user', { userId });

    // Obtener todas las participaciones del usuario
    const participations = await this.participantRepository.getByUserId(userId);

    // Obtener los torneos únicos
    const tournamentIds = [...new Set(participations.map(p => p.tournamentId))];
    
    // Obtener detalles de cada torneo
    const tournaments = await Promise.all(
      tournamentIds.map(id => this.tournamentRepository.getById(id))
    );

    // Filtrar nulls y ordenar por fecha
    const validTournaments = tournaments
      .filter((t): t is Tournament => t !== null)
      .sort((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime());

    logger.debug('GetUserTournaments', 'Found tournaments', { count: validTournaments.length });

    return validTournaments;
  }
}